function a(n) {
  const e = { className: "literal", begin: /[+-]+/, relevance: 0 };
  return { name: "Brainfuck", aliases: ["bf"], contains: [n.COMMENT(/[^\[\]\.,\+\-<> \r\n]/, /[\[\]\.,\+\-<> \r\n]/, { contains: [{ match: /[ ]+[^\[\]\.,\+\-<> \r\n]/, relevance: 0 }], returnEnd: !0, relevance: 0 }), { className: "title", begin: "[\\[\\]]", relevance: 0 }, { className: "string", begin: "[\\.,]", relevance: 0 }, { begin: /(?=\+\+|--)/, contains: [e] }, e] };
}
export {
  a as default
};
